
// // apollo-state
// // [TODO: integrate google-analytics]

// [TODO: Log audio socket state & agent state]

import getUserMedia from 'get-user-media-promise'
import AudioStreamRecorder from '../../audio/AudioStreamRecorder'
import AudioStreamPlayer from '../../audio/AudioStreamPlayer'
import { LO_STO, SESH_STO, setError } from '../../lib'
import loSto from '../../config/loSto'
import seshSto from '../../config/seshSto'
import client from '../../apollo'
import { GET_AGENT_STATE, SET_AGENT_STATE } from '../../apollo/actions'
import { Constants } from '@sukiai/components'
const { AGENT } = Constants

// audioStream recorder (there can be only one)
let audioStreamRecorder = null

// This is a function that just starts a recorder
// This function is called ONLY by the `toggleMute` function within the Agent component
export const startRecording = () => {
  const isAgentInTestMode = loSto.get(LO_STO.AGENT_TEST_MODE)

  if (!isAgentInTestMode) {
    // Normal Recorder behavior
    console.info('Starting recording')
    const pm = getUserMedia({ video: false, audio: true })
    pm.then(mic => {
      stopRecording() // When multiple instances are created for any unknown reason, this will make sure the existing thread will be stopped.
      seshSto.session(SESH_STO.AGENT_RECORDING, true)
      const { agentState } = client.readQuery({ query: GET_AGENT_STATE })
      if (agentState === AGENT.STATE.MUTED) {
        return Promise.resolve() // Keeping return statements in sync, while returning undefined
      }
      // Initialize the recorder
      console.info('MediaStream acquired from mic: [%s]:', mic)
      audioStreamRecorder = new AudioStreamRecorder(mic)
      return Promise.resolve(audioStreamRecorder)
    }).then(micStream => {
      if (!micStream) {
        console.error('Unable to register close stream listener.')
        return
      }
      seshSto.session(SESH_STO.AGENT_MUTED, false)
      micStream.on('close', () => {
        seshSto.session(SESH_STO.AGENT_RECORDING, false)
        seshSto.session(SESH_STO.AGENT_MUTED, true)
        console.info('Recording Stopped.')
      })
    }).catch(err => {
      console.error('Get User Media Error: ', err)
      setError('Could not access microphone.')
      seshSto.session(SESH_STO.AGENT_RECORDING, false)
      client.mutate({
        mutation: SET_AGENT_STATE,
        variables: {
          agentState: AGENT.STATE.MUTED
        }
      })
    })
  } else {
    // Test mode for UI tests, don't use mic instead play audio files
    if (audioStreamRecorder == null) {
      console.info('Starting audio stream player')
      seshSto.session(SESH_STO.AGENT_RECORDING, true)
      audioStreamRecorder = new AudioStreamPlayer()
    }
  }
}

export const stopRecording = () => {
  console.info('Stopping recording')
  audioStreamRecorder && audioStreamRecorder.stop()
  seshSto.session(SESH_STO.AGENT_RECORDING, false)
  seshSto.session(SESH_STO.AGENT_MUTED, true)
  audioStreamRecorder = null
}
